import { InjectionToken, Provider } from '@angular/core';

export const AGILITY_RISK_MODULE_CONFIG = new InjectionToken<RiskModuleConfig>('AGILITY_RISK_MODULE_CONFIG');

export interface RiskModuleConfig {
  serviceProvider?: Provider;
  permissionProvider?: Provider;
  filterProvider?: Provider;
  spinnerProvider?: Provider;
  messageProvider?: Provider;
  theme?: 'preparis' | 'recovery-planner';
  showBreadcrumb?: boolean;
  moduleBaseAddress?: string;
  appHomeAddress?: string;
  dateTimeFormat?: string;
  dateFormat?: string;
}
